﻿document.addEventListener('DOMContentLoaded', () => {
    const $headersearch = document.getElementById('headersearch');
    const $searchToggle = document.getElementById('search-reveal');
    const $searchAgain = document.getElementById('searchAgain');

    if (typeof $headersearch !== 'undefined' && typeof $searchToggle !== 'undefined') {
        
        $searchToggle.addEventListener('click', (event) => {
            $searchToggle.classList.toggle('is-active');
            $headersearch.classList.toggle('is-active');
            if ($headersearch.classList.contains("is-active")) {
                $searchInput.focus();
            }
        });
        document.addEventListener('click', (event) => {
            let isClickInside = false;

            if ($headersearch.contains(event.target) || $searchToggle.contains(event.target)) {
                isClickInside = true;
            }

            if (!isClickInside) {
                $searchToggle.classList.remove('is-active');
                $headersearch.classList.remove('is-active');
            }
        });
    }

    [$headersearch, $searchAgain].forEach(function ($form) {
        if ($form !== null) {
            let $searchInput = $form.getElementsByClassName('input')[0];
            $form.addEventListener("submit", function (e) {
                e.preventDefault();
                if ($searchInput.value.trim() !== "") {
                    $form.submit();
                } else {
                    $searchInput.focus();
                }
            });
        }
    });
});